import styled from 'styled-components';

export const DashboardContainer = styled.div`
  padding: 24px;
  height: calc(100vh - 120px); /* Increased height by reducing margin */
  display: flex;
  flex-direction: column;

  .dashboard-header {
    margin-bottom: 24px; /* Reduced from 32px */

    h1 {
      color: #404040;
      margin-bottom: 8px;
    }

    p {
      color: #757575;
      margin: 0;
    }
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;

    p {
      color: #757575;
      font-size: 16px;
    }
  }

  .error-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;

    p {
      font-size: 16px;
    }
  }

  .portfolio-tabs {
    margin-bottom: 24px;
    border-bottom: 1px solid #e8e8e8;
    flex-shrink: 0;
    display: flex;
    align-items: center;

    .config-button {
      border-radius: 4px;
    }

    .portfolio-menu {
      border: none;

      /* Custom styles for the menu tabs */
      .ant-menu-item {
        border-radius: 8px 8px 0 0;
        margin-right: 4px;

        &:hover {
          background-color: #f0f0f0;
        }

        &.ant-menu-item-selected {
          background-color: #1890ff;
          color: white;

          &::after {
            border-bottom: 2px solid #1890ff;
          }
        }
      }
    }
  }

  .no-selection-message {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    p {
      color: #757575;
      font-size: 18px;
      text-align: center;
    }
  }

  .dashboard-content {
    flex: 1;
    display: flex;
    gap: 24px;
    min-height: 0;
    overflow: hidden; /* Prevent overflow */
    position: relative; /* For status overlay positioning */

    .status-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 10;
      background: rgba(255, 255, 255, 0.95);
      padding: 12px 24px;
      border-radius: 8px;
      margin: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .inline-loading p {
        color: #1890ff;
        margin: 0;
        font-weight: 500;
      }

      .inline-error p {
        color: #ff4d4f;
        margin: 0;
        font-weight: 500;
      }
    }

    /* Country List - Optimized width */
    > :first-child {
      flex-shrink: 0;
      width: 320px; /* Reduced from 350px to give more space to map */
      max-height: 100%;
      overflow-y: auto; /* Allow scrolling if needed */
    }

    /* Map Section - Takes remaining space with better allocation */
    > :last-child {
      flex: 1;
      min-width: 0;
      min-height: 500px; /* Ensure minimum height for map */
      height: 100%;
    }
  }

  .dashboard-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 24px;
  }

  .dashboard-card {
    background: white;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;

    .card-title {
      font-size: 18px;
      font-weight: 600;
      color: #404040;
      margin-bottom: 16px;
    }

    .card-content {
      color: #757575;
      line-height: 1.6;
    }

    .metric-value {
      font-size: 32px;
      font-weight: 700;
      color: #007acc;
      margin-bottom: 8px;
    }

    .metric-label {
      font-size: 14px;
      color: #757575;
      text-transform: uppercase;
      letter-spacing: 1px;
    }
  }

  /* Responsive design */
  @media (max-width: 1200px) {
    .dashboard-content {
      /* On smaller screens, reduce country list width */
      > :first-child {
        width: 280px;
      }
    }
  }

  @media (max-width: 1024px) {
    .dashboard-content {
      flex-direction: column;
      gap: 16px;
      overflow-y: auto;

      /* Reset fixed widths on tablet */
      > :first-child {
        width: 100%;
        max-height: 300px; /* Limit height on mobile to preserve map space */
      }

      > :last-child {
        min-height: 450px; /* Ensure good map height on tablet */
        height: auto;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 16px;
    height: calc(100vh - 100px); /* Optimize mobile height */

    .dashboard-header {
      margin-bottom: 16px;

      h1 {
        font-size: 24px;
      }
    }

    .portfolio-tabs {
      margin-bottom: 16px;
    }

    .dashboard-content {
      > :first-child {
        max-height: 250px; /* Further reduce on mobile */
      }

      > :last-child {
        min-height: 400px; /* Maintain decent map size on mobile */
      }
    }
  }
`;

export const Container = styled.div``;
